export default "__VITE_ASSET__Z23Trkyl__"